import React, { PureComponent } from "react";
import Button from "react-bootstrap/Button";

import types from "./types";
import { Actions, ActionItem, Footer } from "./styled/ModalContent";

const JustifyShim = props => <span {...props} />;

class FooterComponent extends PureComponent {
  static propTypes = {
    actions: types.actions,
    appearance: types.appearance
  };

  static defaultProps = {
    actions: null,
    appearance: "secondary"
  };

  render() {
    const { actions, appearance } = this.props;

    if (!actions) return null;

    return (
      <Footer>
        <JustifyShim />
        <Actions>
          {actions.map(({ text, onClick, ...rest }, idx) => {
            const buttonAppearance = idx
              ? "secondary"
              : appearance || "primary";
            return (
              <ActionItem key={text || idx}>
                <Button variant={buttonAppearance} onClick={onClick} {...rest}>
                  {text}
                </Button>
              </ActionItem>
            );
          })}
        </Actions>
      </Footer>
    );
  }
}

export default FooterComponent;